import { useState } from "react";
// import winGoldPoster from "../../images/WinGoldPoster.jpg";
import contestClosedPoster from "../../images/Contestclosed.png";
import "./HomeTakeoverBanner.css";

// const CAMPA_ENERGY_REWARDS_URL = "https://www.campaenergyrewards.com";

const HomeTakeoverBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="home-takeover-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Contest Closed"
    >
      <button
        type="button"
        className="home-takeover-close"
        onClick={() => setVisible(false)}
        aria-label="Close"
      >
        ×
      </button>
      {/* <a
        href={CAMPA_ENERGY_REWARDS_URL}
        className="home-takeover-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={winGoldPoster}
          alt="Campa Energy Rewards — tap to visit campaenergyrewards.com"
          className="home-takeover-poster"
        />
      </a> */}
      <div className="home-takeover-link">
        <img
          src={contestClosedPoster}
          alt="Contest Closed"
          className="home-takeover-poster"
        />
      </div>
    </div>
  );
};

export default HomeTakeoverBanner;
